import React, { useEffect } from "react";

import "./dashboardEditPieceWrapper.css";
import DashboardWrapper from "../dashboardWrapper";
import Button from "../../../components/button";
import StraightArrowIcon from "../../../assets/icons/straightArrowIcon";
import useWindowDimensions from "../../../utils/useWindowDimensions";

interface DashboardEditPieceWrapperProps {
    children: any;
    step: number;
    totalSteps: number;
    error?: string;
    showError?: boolean;
    nextStepDisabled: boolean;
    onNextStep?: () => void;
    onPrevStep?: () => void;
    onPublish?: () => void;
}

export default function DashboardEditPieceWrapper(props: DashboardEditPieceWrapperProps) {

    const ref = React.createRef<HTMLDivElement>();

    useEffect(() => {
        if (ref.current) {
            ref.current.scrollTop = 0;
        }
    }, [props.step]);

    const mobileError = useWindowDimensions().width < 650;

    return <div className="edit-piece-wrapper">
        <div className={"edit-piece inner-box" + (" step" + props.step)} ref={ref}>
            <div className="steps">
                {props.step > 1 ? <Button className="prev" onClick={props.onPrevStep} thin><StraightArrowIcon rotate={180}/>Prev. Step</Button> : <div/>}
                {props.error && props.showError && !mobileError ? <a className="error">{props.error}</a> : <a>Step {props.step} of {props.totalSteps}</a>}
                {props.step >= props.totalSteps ? <Button className="next" disabled={props.nextStepDisabled} onClick={props.onPublish} thin>Publish</Button> : <Button className="next" disabled={props.nextStepDisabled} onClick={props.onNextStep} thin>Next Step<StraightArrowIcon/></Button>}
                {mobileError && props.showError ? <a className="error mobile">{props.error}</a> : <></>}
                <hr className="indicator"/>
                <hr className="indicator active" style={{
                    width: "calc(((100% - 2*var(--inner-box-padding-inline)) / 5 * " + (props.step-1) + ") + var(--inner-box-padding-inline) )"
                }}/>
            </div>
            <div className="content">
                {props.children}
            </div>
        </div>
    </div>
}